import { api } from './api';

// Native Appointments / Calendar API (beast-native-calendar-v1).
// NOTE: api baseURL already includes '/api' — use BARE '/appointments' paths.

// List the current tenant's appointments (ordered by start time).
export const listAppointments = (params = {}) =>
  api.get('/appointments', { params });

// Read the caller tenant's B.PRO agenda. B.PRO is the source of truth; the
// native appointments table remains mirror/audit only. `sucursal` (optional)
// switches the branch/sucursal (feat-calendar-sucursal-switch-sep2).
export const getBproCalendar = ({ date, date_to, department, sucursal }) =>
  api.get('/bpro/calendar', { params: { date, date_to, department, sucursal } });

// List the sucursales (B.PRO branches) the caller-tenant may switch between.
export const getBproSucursales = () => api.get('/bpro/sucursales');

// Create an appointment.
export const createAppointment = (body) =>
  api.post('/appointments', body);

// Update an appointment.
export const updateAppointment = (appointmentId, body) =>
  api.put(`/appointments/${encodeURIComponent(appointmentId)}`, body);

// Review endpoints are appointment-scoped. Never fetch evidence from CallHistory.
export const listAdvisorReviews = ({ limit = 25, cursor } = {}) =>
  api.get('/appointments/review-queue', { params: { limit, ...(cursor ? { cursor } : {}) } });
export const getAdvisorReview = (id) =>
  api.get(`/appointments/${encodeURIComponent(id)}/review`);
export const getAdvisorReviewTranscript = (id) =>
  api.get(`/appointments/${encodeURIComponent(id)}/review/transcript`);
// Oct 19 (client call, adicionales): `adicionales` = [{descripcion, precio_minor}] is sent ONLY when
// the advisor added line items, so a plain approval keeps the exact two-key body the server always took.
export const approveAdvisorReview = (id, { price_minor, expected_version, adicionales }) =>
  api.post(`/appointments/${encodeURIComponent(id)}/review/approve`,
    Array.isArray(adicionales) && adicionales.length > 0 ? { price_minor, expected_version, adicionales } : { price_minor, expected_version });
export const recoverAdvisorReview = (id, { event, expected_version }) =>
  api.post(`/appointments/${encodeURIComponent(id)}/review/recover`, { event, expected_version });
// datos step B (oct21): the advisor fixed the disputed datum in B.PRO -> datos_dispute.status = atendido.
export const attendDatosDispute = (id) =>
  api.post(`/appointments/${encodeURIComponent(id)}/datos-dispute/atender`);

// Delete an appointment.
export const deleteAppointment = (appointmentId) =>
  api.delete(`/appointments/${encodeURIComponent(appointmentId)}`);
